import { ClientSidePermissionPricingSchemeRoleLinkContainerModel } from "blg-akaun-ts-lib";

export interface RolePricingSchemeLinkState {
  updateAgGrid: boolean;
  selectedRolePricingSchemeLink: ClientSidePermissionPricingSchemeRoleLinkContainerModel;
}

export const initialState: RolePricingSchemeLinkState = {
  updateAgGrid: false,
  selectedRolePricingSchemeLink: null
}

